<template>
  <div class="page">
    <div class="container">
      <div class="row">
        <div class="col s12 right-align">
          <p class="text-user">
            Hello {{ user.username }} |
            <a @click="handleLogout" title="Logout" href="#">Logout</a>
          </p>
        </div>
      </div>
      <div class="row center-box">
        <div class="col s12 box-content">
          <h1 class="heading1">IT Staff</h1>
          Search
          <input
            type="text"
            name="Filter"
            placeholder="Keyword"
            v-model="searchText"
          />
          <div class="row">
            <div v-if="isLoading" class="progress">
              <div class="indeterminate"></div>
            </div>
            <div
              v-for="person in filteredList"
              class="col s12"
              style="padding: 0 1.0rem;"
            >
              <div class="row card-contact">
                <div class="col m3 s3" style="text-align:center;">
                  <img class="responsive-img" :src="person.PhotoBig" />
                </div>
                <div class="col m9 s9">
                  Name: {{ person.Name }}<br />
                  Property: {{ person.Property }}<br />
                  JobTitle: {{ person.JobTitle }}<br />
                  Email: {{ person.Email }}<br />
                  Mobile: {{ person.Mobile }}<br />
                  <a @click="downloadvcard(person)" class="waves-effect waves-light btn-small indigo darken-4"><i class="material-icons left">contacts</i>Download vcard</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "../router";

export default {
  name: "page",
  data() {
    return {
      user: [],
      usercookie: $cookies.get("arch-it-portal"),
      staff: [],
      searchText: "",
      isLoading: true
    };
  },
  computed: {
    filteredList() {
      return this.staff.filter(post => {
        return (
          post.Name.toLowerCase().includes(this.searchText.toLowerCase()) ||
          post.Property.toLowerCase().includes(this.searchText.toLowerCase())
        );
      });
    }
  },
  methods: {
    getuser: function() {
      var notif;
      let params = new URLSearchParams();
      params.append("user", this.usercookie);
      axios({
        method: "post",
        url: "https://www.archipelagointernational.com/api/it-portal/get-user",
        data: params
      }).then(
        response => (
          (this.user = response.data), this.loginstatus(response.data.message)
        )
      );
    },
    loginstatus: function(e) {
      if (e != "Success") {
        //console.log(e);
        router.push({
          name: "Login"
        });
      } else {
        //console.log(e);
      }
    },
    handleLogout: function() {
      $cookies.remove("arch-it-portal");
      router.push({
        name: "Login"
      });
    },
    getPage: function() {
      axios
        .get("https://www.archipelagointernational.com/api/it-portal/it-staff")
        .then(
          response => ((this.staff = response.data), (this.isLoading = false))
        );
    },
    downloadvcard(data) {
      var sendvar = {
          name: data.Name,
          email: data.Email,
          phone: data.Mobile,
          jobtitle: data.JobTitle,
          property: data.Property
      }
      var url = "https://www.archipelagointernational.com/api/it-portal/vcard";
      var filename = data.Email + '.vcf';
      axios({
        method: 'POST',
        url: url,
        responseType: 'blob',
        data: sendvar
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      });
    }
  },
  beforeCreate() {
    var checkcookie = $cookies.get("arch-it-portal");
    if (checkcookie == null) {
      //console.log('kosong');
      router.push({
        name: "Login"
      });
    } else {
      //console.log('login');
    }
  },
  created() {
    this.getuser();
    this.getPage();
  }
};
</script>

<style>
.box-content {
  background: #fff;
  color: #000;
  font-size: 14px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 20px;
  overflow: auto;
}

.box-title {
  font-size: 2em;
}

h1 {
  color: #00205b;
  font-size: 3em;
  text-align: center;
}

.heading1 {
  font-size: 2.2em;
  margin-top: 25px;
}

@media (max-width: 768px) {
  .center-box {
    margin-top: 30px !important;
  }

  .box-title {
    font-size: 17px;
  }

  .box-sm {
    padding-left: 25px;
    padding-right: 25px;
  }
}

.icon-size {
  font-size: 5em;
}

.text-copy {
  font-size: 12px;
  color: #000;
  text-align: center;
}
.text-user {
  margin-top: 60px;
}
.text-user,
.text-user a,
.text-user a:hover {
  color: #fff;
  text-decoration: none;
}

.table tr:nth-child(odd) {
  background-color: #f2f2f2;
}

.table tr:nth-child(even) {
  background-color: #ffffff;
}

@media (max-width: 768px) {
  .text-user {
    margin-top: 50px;
  }

  h1 {
    margin: 0.1rem 0 1.68rem;
  }
}
.card-contact {
  border: solid 1px #ccc;
  padding: 5px;
  margin: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  font-size: 13px;
}
.indigo.darken-4, .indigo.darken-4:hover {
    color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Staff.vue